import getPage from './get-page';

/**
 * @private
 * a check for if the page is cart page
 *
 * @returns {boolean} is page cart
 */
export default function getIsPageCart() {
  return getPage() === 'cart';
}